import * as variables from './variables.js';

declare function require(name:string): any;

// Polyfills
require('./polyfill/matches.js');
require('./polyfill/closest.js');

import './lib/AnimationEasing';

import {Analytics} from '@plaudit/analytics';
Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

require('./component/LanguageSelector.js').init();

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasMobileAccordion > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import SearchForm from './component/HeaderSearchForm';
new SearchForm('.searchArea', '.searchArea__icon', '.searchArea__query', 'open');

import Forms from './component/Forms';
Forms.init();

import featureCarousel from './component/featureCarousel';
const entryCarouselEl = document.querySelector('.__entry .featureCarousel') as HTMLElement;
if (entryCarouselEl) {
	const entryCarousel = new featureCarousel({
		analyticsCategory: 'Feature Carousel',
		carouselClass: 'featureCarousel',
		carouselEl: entryCarouselEl,
		duration: 6000, /* NOTE: if updating this value, update animation duration in CSS */
		doIndicatorClick: true,
	});
}

// @ts-ignore
var Accordion = require('./component/Accordion.js');
var faqsAccordion = new Accordion({
	scope: '.faqs'
});
faqsAccordion.activate();

// @ts-ignore
import * as AnchorLinkSmoothScroll from './component/AnchorLinkSmoothScroll.js';
AnchorLinkSmoothScroll.init();

import * as $ from 'jquery';

import elementOnActivate from './component/element-on-activate';
elementOnActivate($('.pageFooter__backToTop'), () => $('html, body').animate({ scrollTop: 0 }, 'slow') );

import privacyPolicyForm from './component/privacyPolicyForm';
privacyPolicyForm();

import StickyItems from './component/StickyItems';
new StickyItems();